// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-overlay {
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: flex-start; /* Ensure items are aligned to the top */
    align-items: flex-start; /* Align items to the left for padding */
    position: fixed;
    top: 0;
    right: 0;
    width: 243px;
    height: 100%;
    z-index: 2000;
    overflow-y: auto;
    transition: transform 0.3s ease;
    transform: translateX(100%);
    box-shadow: -5px 0 5px -5px rgba(0, 0, 0, 0.2);
    padding-top: 20px; /* Add padding to the top */
}

.menu-overlay.open {
    transform: translateX(0);
}

.menu-overlay .overlay-content {
    background-color: #ffffff;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* Ensure content starts at the top */
    padding: 20px 0;
}

.menu-overlay .menu-items {
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* Ensure items are aligned to the left */
    width: 100%;
    padding-left: 20px; /* Add padding to the left */
}

.menu-overlay .text-wrapper-2,
.menu-overlay .text-wrapper-3,
.menu-overlay .text-wrapper-4,
.menu-overlay .text-wrapper-5,
.menu-overlay .text-wrapper-6,
.menu-overlay .text-wrapper-7 {
    color: #000000;
    font-family: "Inter-Regular", Helvetica;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0.12px;
    line-height: 46px;
    margin: 10px 0;
    cursor: pointer;
    white-space: nowrap;
    text-align: left; /* Ensure text is aligned to the left */
}
.menu-overlay .button-container {
    display: flex;
    flex-direction: column;
    align-items: center; /* Center the buttons horizontally */
    gap: 10px; /* Add vertical gap between buttons */
    margin-top: 20px; /* Optional: Adjust the top margin as needed */
    width: 100%; /* Ensure buttons take the full width */
}

.menu-overlay .button-container .button-login,
.menu-overlay .button-container .button-signup,
.menu-overlay .button-container .button-profile,
.menu-overlay .button-container .button-out {
    width: 80%; /* Adjust the width of the buttons as needed */
}

.menu-overlay .button-instance,
.menu-overlay .button-2 {
    width: 180px;
    margin: 10px 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/MenuOverlay/style.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,2BAA2B,EAAE,wCAAwC;IACrE,uBAAuB,EAAE,wCAAwC;IACjE,eAAe;IACf,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,+BAA+B;IAC/B,2BAA2B;IAC3B,8CAA8C;IAC9C,iBAAiB,EAAE,2BAA2B;AAClD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,qCAAqC;IAC9D,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,yCAAyC;IAClE,WAAW;IACX,kBAAkB,EAAE,4BAA4B;AACpD;;AAEA;;;;;;IAMI,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB,EAAE,uCAAuC;AAC7D;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,oCAAoC;IACzD,SAAS,EAAE,qCAAqC;IAChD,gBAAgB,EAAE,8CAA8C;IAChE,WAAW,EAAE,uCAAuC;AACxD;;AAEA;;;;IAII,UAAU,EAAE,8CAA8C;AAC9D;;AAEA;;IAEI,YAAY;IACZ,cAAc;AAClB","sourcesContent":[".menu-overlay {\n    background-color: #ffffff;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start; /* Ensure items are aligned to the top */\n    align-items: flex-start; /* Align items to the left for padding */\n    position: fixed;\n    top: 0;\n    right: 0;\n    width: 243px;\n    height: 100%;\n    z-index: 2000;\n    overflow-y: auto;\n    transition: transform 0.3s ease;\n    transform: translateX(100%);\n    box-shadow: -5px 0 5px -5px rgba(0, 0, 0, 0.2);\n    padding-top: 20px; /* Add padding to the top */\n}\n\n.menu-overlay.open {\n    transform: translateX(0);\n}\n\n.menu-overlay .overlay-content {\n    background-color: #ffffff;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start; /* Ensure content starts at the top */\n    padding: 20px 0;\n}\n\n.menu-overlay .menu-items {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start; /* Ensure items are aligned to the left */\n    width: 100%;\n    padding-left: 20px; /* Add padding to the left */\n}\n\n.menu-overlay .text-wrapper-2,\n.menu-overlay .text-wrapper-3,\n.menu-overlay .text-wrapper-4,\n.menu-overlay .text-wrapper-5,\n.menu-overlay .text-wrapper-6,\n.menu-overlay .text-wrapper-7 {\n    color: #000000;\n    font-family: \"Inter-Regular\", Helvetica;\n    font-size: 16px;\n    font-weight: 400;\n    letter-spacing: 0.12px;\n    line-height: 46px;\n    margin: 10px 0;\n    cursor: pointer;\n    white-space: nowrap;\n    text-align: left; /* Ensure text is aligned to the left */\n}\n.menu-overlay .button-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* Center the buttons horizontally */\n    gap: 10px; /* Add vertical gap between buttons */\n    margin-top: 20px; /* Optional: Adjust the top margin as needed */\n    width: 100%; /* Ensure buttons take the full width */\n}\n\n.menu-overlay .button-container .button-login,\n.menu-overlay .button-container .button-signup,\n.menu-overlay .button-container .button-profile,\n.menu-overlay .button-container .button-out {\n    width: 80%; /* Adjust the width of the buttons as needed */\n}\n\n.menu-overlay .button-instance,\n.menu-overlay .button-2 {\n    width: 180px;\n    margin: 10px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
